export default async function obtenerConcesiones(idContribuyente) {
    const endpoint = `/api/concesiones/obtenerPorIdContribuyente/${idContribuyente}`;
    try {
        const response = await fetch(endpoint);
        if (response.status === 400) return [];
        const { data } = await response.json();
        return data;
    } catch (_) {
        return [];
    }
}
